import axios from "axios";

import { ENV_CONFIG } from "@configs/env";

const DEFAULT_TIMEOUT = 1000 * 10;

export const axiosBase = axios.create({
	baseURL: ENV_CONFIG.BASE_API_UTL,
	headers: {
		"Content-Type": "application/json",
	},
	timeout: DEFAULT_TIMEOUT,
});

export const axiosBaseHub = axios.create({
	baseURL: ENV_CONFIG.BASE_HUB_URL,
	headers: {
		"Content-Type": "application/x-www-form-urlencoded",
	},
	timeout: DEFAULT_TIMEOUT,
});

export const axiosBaseBanner = axios.create({
	baseURL: ENV_CONFIG.BASE_URL_BANNER,
	headers: {
		"Content-Type": "application/json",
	},
	timeout: DEFAULT_TIMEOUT,
});

export const axiosBaseBucket = axios.create({
	baseURL: ENV_CONFIG.BASE_BUCKET_URL,
	headers: {
		"Content-Type": "application/json",
	},
	timeout: DEFAULT_TIMEOUT,
});

export const axiosBaseToysGate = axios.create({
	baseURL: ENV_CONFIG.TOYS_GATE_URL,
	headers: {
		"Content-Type": "application/json",
	},
	timeout: DEFAULT_TIMEOUT,
});
